import React from 'react'
import { ContactContainer } from '../Styles/Sections'
import { LCTitle } from '../Styles/Fonts'
import { Button, ButtonContainer } from '../Styles/Buttons'
import { ContactDiv, ContactInfoWrapper } from '../Styles/ContactSection'

const ContactSection = () => {
	return (
		<ContactContainer id="contact">
			<ContactDiv>
				<LCTitle>Let&apos;s chat!</LCTitle>

				<ContactInfoWrapper>
					<ButtonContainer>
						<a
							href="https://www.linkedin.com/in/antoniagranit/"
							target="_blank"
							rel="noreferrer"
						>
							<Button>LinkedIn</Button>
						</a>
						<span className="sr-only">LinkedIn</span>
						<a
							href="https://github.com/AntoniaGranit"
							target="_blank"
							rel="noreferrer"
						>
							<Button>GitHub</Button>
						</a>
						<span className="sr-only">GitHub</span>
					</ButtonContainer>
				</ContactInfoWrapper>
			</ContactDiv>
		</ContactContainer>
	)
}

export default ContactSection
